import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaCreditCard,
  FaLock,
  FaRocket,
  FaGlobe,
  FaShieldAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const PaymentGatewayIntegrationInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Payment Gateway Integration in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Seamless Transactions</Subheading>}
        heading={
          <Heading>
            Payment Gateway <span tw="text-primary-500">Integration</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer expert payment gateway integration
            services in **Bur Dubai**, enabling your e-commerce store to process
            secure, fast, and reliable transactions. Simplify payments and
            enhance customer trust with our tailored solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce checkout
          "https://images.unsplash.com/photo-1580048915913-4f8f5cb481c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment security
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Credit card payment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Integrate Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Payment Integration in Bur Dubai"
        description="We streamline payments to boost your e-commerce success."
        cards={[
          {
            icon: <FaCreditCard color="#ff5464" size={40} />,
            title: "Multiple Gateways",
            description: "Integrate PayPal, Stripe, local options, and more.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Secure Payments",
            description: "End-to-end encryption for safe transactions.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Quick integration without disrupting your store.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Global Reach",
            description: "Support multi-currency and international payments.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Fraud Protection",
            description: "Advanced tools to prevent fraudulent transactions.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Service",
            description: "Reliable solutions for Bur Dubai businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Payment Integration Process"
        description={
          <Description>
            We ensure smooth payment processing with a structured approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Assess your payment needs and preferences.</li>
              <li>Selection: Recommend the best gateways for your store.</li>
              <li>
                Integration: Seamlessly connect gateways to your platform.
              </li>
              <li>Testing: Verify security, speed, and functionality.</li>
              <li>Launch: Enable live transactions with full support.</li>
              <li>Maintenance: Monitor and update for ongoing reliability.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742111-a301076d9d18?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment system integration
          "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure transaction
          "https://images.unsplash.com/photo-1571867424488-4565932edb41?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment gateway testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Payment Integration Wins in Bur Dubai"
        description="Our integration services have enhanced local e-commerce."
        cards={[
          {
            icon: <FaCreditCard color="#ff5464" size={40} />,
            title: "Smooth Transactions",
            description: "Integrated payments for 50+ daily orders.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Deployment",
            description: "Added a gateway in 48 hours for a retailer.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "98% approval from payment integration clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Easy Payments?</Subheading>}
        heading="Payment Gateway Integration in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert payment gateway integration
            in Bur Dubai. Make transactions secure, fast, and hassle-free for
            your customers—get started today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1593510987185-1ec2256148a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile payment
          "https://images.unsplash.com/photo-1534224039826-c7a0fb1c5c1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai skyline for local context
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
